/**
 * Centralized Supabase configuration constants.
 * All frontend code should import from here instead of hardcoding URLs.
 */

export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_URL;

export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

export const SUPABASE_PROJECT_ID =
  import.meta.env.VITE_SUPABASE_PROJECT_ID;

/** Site URL for self-references (legal pages, emails, etc.) */
export const SITE_URL =
  import.meta.env.VITE_SITE_URL || window.location.origin;

/** Build a full edge function URL */
export function edgeFunctionUrl(functionName: string): string {
  return `${SUPABASE_URL}/functions/v1/${functionName}`;
}

/** Build a Supabase dashboard link */
export function supabaseDashboardUrl(path: string): string {
  return `https://supabase.com/dashboard/project/${SUPABASE_PROJECT_ID}/${path}`;
}
